module.exports = __webpack_public_path__ + "assets/sf-consulting.af629e22.svg";